
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/parking",
      function () {
        return require("private-next-pages/[locale]/parking/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/parking"])
      });
    }
  